import { PayloadAction } from "@reduxjs/toolkit";
import { JsonApiDocument } from "../../../../common/ApiSchemaType/Types";
import { IExtract, ICreateExtractState, ExtractModes } from "./Types";

export const Reducer = {
  setNewExtract: (state: ICreateExtractState, action: PayloadAction<IExtract>): void => {
    state.newExtract = action.payload;
  },
  saveExtract: (state: ICreateExtractState, action: PayloadAction<JsonApiDocument>): void => {
    state.savedExtract = action.payload;
  },
  /**
   * State to maintain theextract modes of either create, edit or view
   */
  setExtractMode: (state: ICreateExtractState, action: PayloadAction<ExtractModes>): void => {
    state.mode = action.payload;
  },
  /**
   * Set the edited extract detail 
   * @param state - editExtractDetail (details of edited extracts)
   * @param action - updates the state editExtractDetail
   */
  setEditExtractDetail: (state: ICreateExtractState, action: PayloadAction<IExtract>): void => {
    state.editExtractDetail = action.payload;
  },
  setPreviousEditExtractDetail: (state: ICreateExtractState, action: PayloadAction<IExtract>): void => {
    state.editPreviousExtractDetail = action.payload;
  },
  /**
   * Boolean flag to check if the details are updated
   * @param state isDetailsUpdated
   * @param action payload
   */
  setDetailsUpdated: (state: ICreateExtractState, action: PayloadAction<boolean>): void => {
    state.isDetailsUpdated = action.payload;
  },
};
